export default __webpack_public_path__ + "static/media/FTM-BNB.20708ec7.svg";